import type { Campaign } from 'c-sdk';

/**
 * The warning icons beside the campaign's Reporting tab, and whether the tab controls render at
 * all. Each flag reads the campaign's notices first, then its data status.
 */
export const pcaTabStatus = (
    campaign:
        | Pick<Campaign, 'notices' | 'data_status' | 'booking_summary_validated'>
        | null
        | undefined,
) => {
    const hasAwaitingData = !!(
        campaign?.notices?.overall?.awaiting_data || campaign?.data_status?.awaiting_data
    );
    const hasInspectingData = !!(
        campaign?.notices?.overall?.inspecting_data || campaign?.data_status?.inspecting_data
    );
    const needsBookingValidation = !!(
        campaign?.booking_summary_validated === false ||
        campaign?.notices?.overall?.awaiting_booking_plan ||
        campaign?.data_status?.awaiting_booking_plan
    );

    return { hasAwaitingData, hasInspectingData, needsBookingValidation };
};

/** The controls hide only for a validated campaign with nothing to warn about. */
export const hidePcaTabControls = (
    campaign:
        | Pick<Campaign, 'notices' | 'data_status' | 'booking_summary_validated'>
        | null
        | undefined,
    alwaysShowTitle: boolean,
) => {
    const status = pcaTabStatus(campaign);
    return (
        !alwaysShowTitle &&
        !status.hasAwaitingData &&
        !status.hasInspectingData &&
        !status.needsBookingValidation &&
        campaign?.booking_summary_validated === true
    );
};
